import { singleton } from 'tsyringe';
import { 提示, 提示状态, 提示类型 } from '@/store/notifyState';
import { 确认, 确认状态, 确认类型 } from '@/store/confirmState';
import { 提示Service as Abstract提示Service } from 'zr-arch';

@singleton()
export class 提示Service extends Abstract提示Service {
    提示成功(内容: string): void {
        提示状态.新增提示(new 提示('成功', 内容));
    }

    提示警告(内容: string): void {
        提示状态.新增提示(new 提示('警告', 内容));
    }

    提示错误(内容: string): void {
        提示状态.新增提示(new 提示('错误', 内容));
    }

    提示信息(内容: string): void {
        提示状态.新增提示(new 提示('信息', 内容));
    }

    async 确认操作(
        内容: string | string[],
        类型?: 确认类型,
        标题?: string,
        确认文本?: string,
        取消文本?: string
    ): Promise<boolean> {
        if (typeof 内容 === 'string') {
            return 确认状态.开始确认(new 确认([内容 as string], 类型, 标题, 确认文本, 取消文本));
        } else {
            return 确认状态.开始确认(new 确认(内容 as string[], 类型, 标题, 确认文本, 取消文本));
        }
    }
}
